/* eslint-disable max-len */
import React from 'react';
import { Content, TableV2, Flex, Text, Button, TabPane } from '@leverege/ui-elements';
import PropTypes from 'prop-types';
import { ValueCache } from '@leverege/value-cache';
import { format } from 'date-fns';
import { TitleBar } from '@leverege/ui-plugin';
import { connect } from 'react-redux';
import I18N from '@leverege/i18n';
import Export from "./file/Util.js";
import TablePagination from "../../dataViewers/table/TablePagination.js";
import Paginator from "../../screens/group/Paginator.js";
import Util from "./Utils.js";
import S from './BulkCreateResults.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.imagine.forms.BulkCreateResults');
const {
  sort,
  defaultGetAttributes,
  bulkCreateAttributeFilter
} = Util;
class BulkCreateResults extends React.Component {
  static propTypes = {
    getAttributes: PropTypes.func,
    titleVariant: PropTypes.string,
    // eslint-disable-next-line react/no-unused-prop-types
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    tableClassName: PropTypes.string,
    tableBodyErrorClassName: PropTypes.string,
    tableBodySuccessClassName: PropTypes.string
  };
  static defaultProps = {
    getAttributes: defaultGetAttributes,
    titleVariant: 'dialogTitle',
    get title() {
      return t('title');
    },
    tableClassName: S.resultsTable,
    tableBodyErrorClassName: S.resultsTableBodyError,
    tableBodySuccessClassName: S.resultsTableBodySuccess
  };
  getAttributes() {
    const {
      getAttributes,
      target
    } = this.props;
    return this.cache.calc((target, getAttributes) => {
      const attrs = getAttributes(target, bulkCreateAttributeFilter) || [];
      // sort them
      attrs.sort(sort);
      return attrs;
    }, target, getAttributes);
  }
  getSuccessAndFailures() {
    const {
      results
    } = this.props;
    return this.resultsCache.calc(results => {
      return [results.filter(d => !d?.success), results.filter(d => !!d?.success)];
    }, results);
  }
  constructor(props) {
    super(props);
    this.tableRef = /*#__PURE__*/React.createRef();
    this.state = {
      tabId: 'success'
    };
    this.cache = new ValueCache();
    this.resultsCache = new ValueCache();
    this.successColumns = [{
      id: 'entry',
      Header: t('entryLine'),
      minWidth: 160,
      accessor: rowObj => rowObj.index + 1
    }, ...this.getAttributes().map(attr => {
      return {
        id: attr.id,
        Header: attr.displayName,
        minWidth: 160,
        Cell: ({
          value
        }) => String(value),
        accessor: rowObj => {
          if (attr.valueType === 'timestamp') {
            return !Number.isNaN(Date.parse(attr.get(rowObj.data))) ? format(attr.get(rowObj.data), 'hh:mm a MM/d/yyyy') : '';
          }
          const val = attr.get(rowObj.data);
          return typeof val === 'object' && val != null ? val?.value : val;
        }
      };
    })];
    this.errorColumns = [{
      id: 'entry',
      get Header() {
        return t('entryLine');
      },
      minWidth: 160,
      accessor: 'index',
      Cell: ({
        value
      }) => {
        return value + 1;
      }
    }, {
      id: 'error',
      get Header() {
        return t('error');
      },
      minWidth: 160,
      accessor: rowObj => rowObj?.error?.message
    }, {
      id: 'name',
      get Header() {
        return t('name');
      },
      minWidth: 160,
      accessor: rowObj => rowObj?.original?.name
    }];
    this.paginator = new Paginator();
  }
  renderFooter = ({
    pageCount,
    pageIndex,
    pageSize,
    ...rest
  }) => {
    const {
      tabId
    } = this.state;
    const [failures, successes] = this.getSuccessAndFailures();
    const paginatorData = {
      count: pageCount,
      page: pageIndex,
      perPage: pageSize,
      items: tabId === 'error' ? failures : successes
    };
    this.paginator.setData(paginatorData);
    return /*#__PURE__*/_jsx(TablePagination, {
      paginator: this.paginator
    });
  };
  downloadErrorCSV = () => {
    const {
      objectType
    } = this.props;
    const [failures] = this.getSuccessAndFailures();
    Export.exportCSV(failures, this.errorColumns, 'Bulk_Add_Failures.csv', objectType);
  };
  render() {
    const {
      onCancel,
      titleVariant,
      titleIcon,
      relationship,
      fileName,
      tableClassName,
      tableBodySuccessClassName,
      tableBodyErrorClassName
    } = this.props;
    const {
      tabId
    } = this.state;
    const [failures, successes] = this.getSuccessAndFailures();
    const targetName = relationship.blueprint.namePlural;
    const columns = tabId === 'error' ? this.errorColumns : this.successColumns;
    const shouldShowErrorsTab = failures.length !== 0;
    const shouldShowJustSuccessTab = failures.length === 0 && tabId === 'success';
    const bulkCreateResultsTitle = t('bulkCreateResultsTitle', {
      targetName
    });
    return (
      /*#__PURE__*/
      // assign a width here
      _jsxs(Content, {
        relative: true,
        style: {
          width: '100vw',
          height: '91vh'
        },
        children: [/*#__PURE__*/_jsx(Content.Header, {
          variant: "formHeader",
          children: /*#__PURE__*/_jsx(Flex, {
            variant: "colM",
            children: /*#__PURE__*/_jsx(TitleBar, {
              variant: titleVariant,
              title: bulkCreateResultsTitle,
              icon: titleIcon
            })
          })
        }), /*#__PURE__*/_jsxs(Content.Area, {
          variant: "formBodyBulk|formBody",
          style: {
            height: '63vh',
            paddingBottom: 16,
            overflow: 'hidden'
          },
          children: [/*#__PURE__*/_jsxs(Flex, {
            direction: "row",
            children: [/*#__PURE__*/_jsxs(Text, {
              variant: "formTitle",
              children: [t('title'), " "]
            }), /*#__PURE__*/_jsx("i", {
              style: {
                paddingTop: '4px',
                paddingLeft: '8px',
                color: '#15B982'
              },
              className: "fa fa-check-circle"
            })]
          }), /*#__PURE__*/_jsxs(Flex, {
            variant: "bulkCreateResults",
            children: [/*#__PURE__*/_jsxs(Text, {
              variant: "formSubtitle",
              children: [t('formSubtitle'), "  "]
            }), /*#__PURE__*/_jsx(Text, {
              variant: "formBody",
              children: fileName
            }), /*#__PURE__*/_jsx(Button, {
              variant: "tertiaryBulkCreate",
              icon: tIcon('downloadIcon', 'fa fa-download'),
              onClick: this.downloadErrorCSV,
              className: S.downloadErrorButton,
              children: t('downloadErrors')
            })]
          }), /*#__PURE__*/_jsxs("div", {
            style: {
              borderRadius: '8px',
              border: '1px solid #CED6DE',
              height: 'calc(100vh - 300px)'
            },
            children: [/*#__PURE__*/_jsx(Flex, {
              direction: "row",
              justify: "space-between",
              children: /*#__PURE__*/_jsxs(TabPane, {
                activeId: tabId,
                onTabClicked: evt => {
                  this.setState({
                    tabId: evt.value
                  });
                },
                variant: shouldShowJustSuccessTab ? 'bulkCreateSuccess' : tabId === 'error' ? 'bulkCreateError' : 'bulkCreateSuccessError',
                style: {
                  flex: 1
                },
                children: [shouldShowErrorsTab && /*#__PURE__*/_jsx(TabPane.Tab, {
                  tabName: t('errorsTab', {
                    count: failures.length
                  }),
                  tabId: "error"
                }), /*#__PURE__*/_jsx(TabPane.Tab, {
                  tabName: t('successTab', {
                    targetName,
                    count: successes.length
                  }),
                  tabId: "success",
                  style: {
                    textTransform: 'capitalize'
                  }
                })]
              })
            }), /*#__PURE__*/_jsx(TableV2, {
              className: tableClassName,
              bodyClassName: tabId === 'success' ? tableBodySuccessClassName : tableBodyErrorClassName,
              variant: "pairingTable",
              tableref: this.tableRef,
              data: failures.length === 0 ? successes : tabId === 'error' ? failures : successes,
              columns: columns,
              FooterComponent: this.renderFooter,
              getRowProps: (row, props, style = {}) => {
                return props;
              },
              paginate: true
            })]
          })]
        }), /*#__PURE__*/_jsx(Content.Footer, {
          variant: "formButtons",
          children: /*#__PURE__*/_jsxs(Flex, {
            variant: "rowMEnd",
            children: [/*#__PURE__*/_jsx(Flex, {
              variant: "rowMEnd",
              children: /*#__PURE__*/_jsx(Button, {
                onClick: onCancel,
                variant: "primary",
                children: t('primaryButton')
              })
            }), /*#__PURE__*/_jsx(Text, {
              variant: "inputCaptionSmallError"
            })]
          })
        })]
      })
    );
  }
}
export default connect((state, props) => {
  return {
    fileName: state.ui.uploadedFileName
  };
})(BulkCreateResults);